export const applySpecialVat = () => {
    return (
      window.changeScript &&
      window.changeScript.methods &&
      typeof window.changeScript.methods.isSpecialVat === "function" &&
      window.changeScript.methods.isSpecialVat()
    );
  }